import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { AppShell } from './components/AppShell';
import { useAuth } from './lib/AuthContext';
import { AboutPage } from './pages/AboutPage';
import { AccessDeniedPage } from './pages/AccessDeniedPage';
import { AdminPage } from './pages/AdminPage';
import { AppDetailPage } from './pages/AppDetailPage';
import { AppsPage } from './pages/AppsPage';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { RequestPage } from './pages/RequestPage';
import { StatusPage } from './pages/StatusPage';

function RequireAuth() {
  const { user, guest, loading } = useAuth();
  if (loading) {
    return (
      <Box minHeight="60vh" display="flex" alignItems="center" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }
  if (!user && !guest) return <Navigate to="/login" replace />;
  if (user?.mustChangePassword) return <Navigate to="/change-password" replace />;
  return <Outlet />;
}

export default function App() {
  const { denied } = useAuth();
  if (denied) return <AccessDeniedPage ip={denied.ip} />;
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/change-password" element={<ChangePasswordPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<AppShell />}>
          <Route index element={<HomePage />} />
          <Route path="apps" element={<AppsPage />} />
          <Route path="apps/:slug" element={<AppDetailPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="request" element={<RequestPage />} />
          <Route path="status" element={<StatusPage />} />
          <Route path="admin" element={<AdminPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
